module.exports = __webpack_public_path__ + "e3798177a683ae8650155b0e575f1d14.svg";